import React from 'react';
import * as styles from './index.module.less';
import NottaLogo from '@/images/Logo-Notta-Dark.png';

interface IProps {
  type?: string;
}

const NottaLogoLink = ({ type = 'ja' }: IProps) => {
  return (
    <a href={type === 'ja' ? '/' : `/${type}`}>
      <img src={NottaLogo} alt="Notta" className={`${type === 'ja' ? styles.notta_logo : styles.notta_logo_en}`} />
    </a>
  );
};
export default NottaLogoLink;
